import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiButton, TuiHint } from '@taiga-ui/core';
import { SharedModule } from '@src/app/shared';
import { IconModule } from '@src/app/modules/icon';

import { MediaRecorderComponent } from './media-recorder.component';

@NgModule({
  declarations: [MediaRecorderComponent],
  imports: [CommonModule, IconModule, SharedModule, TuiButton, ...TuiHint],
  exports: [MediaRecorderComponent],
})
export class MediaRecorderModule {}
